import { createFileRoute, Outlet } from '@tanstack/react-router'
import TaskList from '../../../../../containers/TaskList'
import { tasksContextSearchSchema } from './search-schemas'

export const Route = createFileRoute(
  '/_authenticated/project/$projectId/tasks'
)({
  validateSearch: tasksContextSearchSchema,
  component: ProjectTasksWrapper
})

function ProjectTasksWrapper() {
  return (
    <>
      <TaskList />
      <Outlet />
    </>
  )
}
